// ADR-0142 — el cierre por falta de respuesta, visto desde el panel del
// jefe y del gerente de postventa.
//
// Todo lo que tiene fecha (`autoApprovalAt`, `reopenableUntil`) lo
// proyecta el servidor; acá sólo se traduce a palabras: por qué un
// propietario no recibe los correos, qué aviso no salió, y si el ciclo
// vigente lo abrió una reapertura (no un «No conforme»).
import {
  OBSERVATION_REOPENED_EVENT_TYPE,
  type ClosureBlockReason,
  type FindingTimelineEntry,
  type PostventaClosureBlocked,
} from "@bitacorapro/api-types";

/** El motivo del bloqueo en lenguaje llano: qué tiene que resolver el
 *  jefe por otra vía (teléfono, WhatsApp) para que el aviso llegue. */
export const MOTIVO_BLOQUEO: Record<ClosureBlockReason, string> = {
  sin_propietario: "La unidad no tiene propietario vinculado",
  cuenta_no_activa: "El propietario no ha activado su cuenta",
  envio_fallido: "El correo no se pudo entregar",
};

/** Qué aviso no salió. */
export function avisoBloqueado(
  b: Pick<PostventaClosureBlocked, "notice" | "reminderNumber">
): string {
  if (b.notice === "closed") return "Aviso de cierre";
  return b.reminderNumber != null ? `Recordatorio ${b.reminderNumber}` : "Recordatorio";
}

/** «3 intentos» — cuántas veces se intentó el aviso. */
export function intentosLabel(n: number): string {
  return `${n} ${n === 1 ? "intento" : "intentos"}`;
}

/**
 * ¿El ciclo vigente lo abrió la reapertura de un cierre por falta de
 * respuesta? Es el último hito que movió el estado: si es
 * `observation_reopened`, sí; si es un «No conforme» (o cualquier otro
 * movimiento), no. El hilo llega ascendente (ADR-0085).
 */
export function reabiertaTrasCierre(
  timeline: readonly Pick<FindingTimelineEntry, "eventType" | "fromStatus" | "toStatus">[]
): boolean {
  for (let i = timeline.length - 1; i >= 0; i--) {
    const ev = timeline[i]!;
    if (ev.eventType === OBSERVATION_REOPENED_EVENT_TYPE) return true;
    if (ev.toStatus != null && ev.toStatus !== ev.fromStatus) return false;
  }
  return false;
}
